<div
  [attr.class]="'info-help ' + (additionalClass ? 'info-help--' + additionalClass : '')"
  (click)="openBookingHelpMessage()"
  (mouseenter)="toggleBookingHelpMessage()"
  (mouseleave)="toggleBookingHelpMessage()"
>
  <i class="fa-regular fa-square-info tooltip-icon"></i>
  <div *ngIf="isBookingHelpMessage" class="tooltip tooltip--bottom tooltip--visible">
    {{ text | translate }}
  </div>
</div>

<app-info-modal *ngIf="modalVars[modalId]" class="lm-modal" [attr.id]="modalId" id="{{ modalId }}">
  <div class="lm-modal__body lm-modal__body--no-head">
    <p class="lm-modal__text info-help__text">
      {{ text | translate }}
    </p>
    <button sparkButton variant="primary" class="button--modal-close" (click)="modalService.close(this.modalId)">
      {{ 'reservation-form.more-information-close-button' | translate }}
    </button>
  </div>
</app-info-modal>
